import { NetworkActionPrefix } from '../utils/constants';
import defaults from '../api/defaults';
import { combineReducers, networkObjectLoadReducer } from '../utils/reducerFactory';

const livingStrategyDashboard = combineReducers({
    livingStrategyDashboardReport: networkObjectLoadReducer(NetworkActionPrefix.LOAD_LIVING_STRATEGY_DASHBOARD_REPORT_PREFIX, defaults.NetworkObject)
});

export default livingStrategyDashboard;